<template>
  <div class="app-promo-page">
    <b-row class="my-5">
      <b-col class="text-center text-sm-right" cols="12" sm="4">
        <b-img v-if="isAssurant" class="hero" fluid src="https://real-links-assets.s3.eu-west-2.amazonaws.com/assurant-K8e1Q/2023-05-30/01H1PTHBFT73Q4V599E5G7ZRS0/monster-app.png"/>
        <b-img v-else class="hero" fluid src="/static/images/illustrations/1.svg"/>
      </b-col>
      <b-col cols="12" sm="8">
        <h1 v-if="isAssurant">Download the TalentSpotters Referrals app</h1>
        <h1 v-else>Download the Referrals app</h1>

        <p class="lead">Get notifications &amp; share vacancies on the go!</p>
        <div class="d-flex flex-row my-3">
          <a :href="appStoreUrl" target="_blank">
            <img alt="Download on the App Store" src="@src/assets/apple-app-store.png" width="150px"/>
          </a>
          <div class="mx-3"/>
          <a :href="googlePlayUrl" target="_blank">
            <img alt="Get it on Google Play" src="@src/assets/google-play-store.png" width="150px"/>
          </a>
        </div>

        <p v-if="isAssurant">And sign-in with your <strong>assurant.com</strong> login when prompted.</p>
        <p v-else-if="shortCode">And enter code <strong>{{ shortCode }}</strong> when prompted.</p>
        <p v-else-if="isRecruiter">Your referrals platform has not been configured to use the app. Please reach out to Customer Success.</p>
        <p v-else>Your referrals platform has not been configured to use the app. Please speak to an administrator.</p>

        <ul>
          <li v-if="canSyncContacts">Sync contacts, browse jobs &amp; refer your friends.</li>
          <li v-else>Browse jobs &amp; share opportunities to your friends.</li>
          <li>Get notifications when your friends apply, and when they move through the interview process.</li>
        </ul>
      </b-col>
    </b-row>
    <div class="mt-5 text-center text-muted">
      <p class="m-0"><small>Apple logo and App Store are trademarks of Apple Inc.</small></p>
      <p class="m-0"><small>Google Play and the Google Play logo are trademarks of Google LLC.</small></p>
    </div>
  </div>
</template>

<script>
import qs from 'querystring';
import { mapRoot } from '@src/mixins/root';

export default {
  computed: {
    ...mapRoot([ 'hostname', 'company', 'user', 'isRecruiter', 'isAssurant', 'isEXPD8', 'isGWR' ]),
    appStoreUrl() {
      if (this.isAssurant) {
        // https://apps.apple.com/gb/app/talentspotters-referrals/id6446709876
        return `https://apps.apple.com/gb/app/talentspotters-referrals/id6446709876?${qs.stringify({
          utm_source: 'talentspotters-site',
          utm_campaign: this.hostname,
        })}`;
      } else {
        // https://apps.apple.com/gb/app/real-links/id1522475298
        return `https://apps.apple.com/app/employee-referrals/id1522475298?${qs.stringify({
          utm_source: 'real-links-platform',
          utm_campaign: this.hostname,
        })}`;
      }
    },
    googlePlayUrl() {
      if (this.isAssurant) {
        // https://play.google.com/store/apps/details?id=io.reallinks.apps.assurant.android
        return `https://play.google.com/store/apps/details?${qs.stringify({
          id: 'io.reallinks.apps.assurant.android',
          utm_source: 'talentspotters-site',
          utm_campaign: this.hostname,
        })}`;
      } else if (this.isEXPD8) {
        // https://play.google.com/store/apps/details?id=io.reallinks.apps.android.pub
        return `https://play.google.com/store/apps/details?${qs.stringify({
          id: 'io.reallinks.apps.android.pub',
          utm_source: 'real-links-platform',
          utm_campaign: this.hostname,
        })}`;
      } else if (this.isGWR) {
        // https://play.google.com/store/apps/details?id=io.reallinks.apps.android.v2
        return `https://play.google.com/store/apps/details?${qs.stringify({
          id: 'io.reallinks.apps.android.v2',
          utm_source: 'real-links-platform',
          utm_campaign: this.hostname,
        })}`;
      } else {
        // https://play.google.com/store/apps/details?id=io.reallinks.apps.android.pub
        return `https://play.google.com/store/apps/details?${qs.stringify({
          id: 'io.reallinks.apps.android.pub',
          utm_source: 'real-links-platform',
          utm_campaign: this.hostname,
        })}`;
      }
    },
    canSyncContacts() {
      const { canSyncContacts } = (this.company || {}).sitePreferences || {};
      return canSyncContacts || null;
    },
    shortCode() {
      const { shortCode } = this.company || {};
      return shortCode || null;
    },
  }
};
</script>

<style lang="scss">
.app-promo-page {
  img.hero {
    max-height: 200px;

    @media (min-width: 576px) {
      max-height: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/User/AppPromo.vue